import axios from "axios";
import { API_BASE } from "../config/apiConfig";

const baseURL = (API_BASE || "").replace(/\/+$/, "");

const apiClient = axios.create({
  baseURL,
  timeout: 20000,
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;

  const isFormData =
    typeof FormData !== "undefined" && config.data instanceof FormData;
  if (isFormData) {
    delete config.headers?.["Content-Type"];
    delete config.headers?.common?.["Content-Type"];
    delete config.headers?.post?.["Content-Type"];
    delete config.headers?.put?.["Content-Type"];
  }
  return config;
});

apiClient.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("isLoggedIn");
    }
    return Promise.reject(err);
  }
);

export default apiClient;
